

// import { useContext } from 'react';
// import { useLocation } from 'react-router-dom'; // Import useLocation to get the current route
// import './Navbar.css';
// import DataContext from '../../stores/DataContextProvider';
// import Button from '../controllers/Button';

// function Navbar() {
//   const { 
//     level, 
//     updateLevel, 
//     updateM, 
//     updateSM, 
//     updateG, 
//     updateSK, 
//     updateFolderPath, 
//     folderPath,
//     handleBackOneLevel 
//   } = useContext(DataContext);
  
//   const location = useLocation(); // Get the current route

//   // Handler to navigate to home
//   function handleHome(e) {
//     e.preventDefault();
//     window.location.href = '/home';
//   }

//   const handleSignOut = () => {
//     window.location.href = '/';
//   };

//   function handleBack(e) {
//     e.preventDefault();

//     if (level > 0) {
//       updateLevel(prevLevel => prevLevel - 1);
//       handleBackOneLevel(); // Call the function to handle back navigation
      
//       // Resetting context values based on the current level
//       switch (level) {
//         case 1:
//           updateM("");
//           break;
//         case 2:
//           updateSM("");
//           break;
//         case 3:
//           updateG("");
//           break;
//         case 4:
//           updateSK("");
//           break;
//         default:
//       }

//       // Update folder path by removing the last segment
//       if (folderPath) {
//         const pathParts = folderPath.split('/');
//         pathParts.pop();
//         const newPath = pathParts.join('/');
//         updateFolderPath(newPath);
//         console.log('New Folder Path after Back:', newPath);
//       }
//     }
//   }

//   const showBackButton = !['/level', '/instruction'].includes(location.pathname) && !location.pathname.startsWith('/testscreen');

//   return (
//     <div className="navContainer"> 
//       <div className="buttonContainer">
//         {/* Show Home button only after level > 0 */}
//         {level > 0 && <Button handleClick={handleHome} buttonName="Homepage" />}
//         {showBackButton && <Button handleClick={handleBack} buttonName="Back" />}
//         <Button handleClick={handleSignOut} buttonName="Sign out" />
//       </div>
//     </div>
//   );
// }

// export default Navbar;


import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import './Navbar.css';
import DataContext from '../../stores/DataContextProvider';
import Button from '../controllers/Button';

function Navbar() {
  const { 
    level, 
    updateLevel, 
    updateM, 
    updateSM, 
    updateG, 
    updateSK, 
    updateFolderPath, 
    folderPath,
    handleBackOneLevel 
  } = useContext(DataContext);
  
  const location = useLocation();

  // Handler to navigate to home
  function handleHome(e) {
    e.preventDefault();
    window.location.href = '/home';
  }

  const handleSignOut = () => {
    window.location.href = '/';
  };

  function handleBack(e) {
    e.preventDefault();

    if (level > 0) {
      updateLevel(prevLevel => prevLevel - 1);
      handleBackOneLevel();

      // Reset context values according to the current level
      switch (level) {
        case 1:
          updateM("");
          break;
        case 2:
          updateSM("");
          break;
        case 3:
          updateG("");
          break;
        case 4:
          updateSK("");
          break;
        default:
      }

      // Remove last segment from folderPath
      if (folderPath) {
        const pathParts = folderPath.split('/');
        pathParts.pop();
        const newPath = pathParts.join('/');
        updateFolderPath(newPath);
        console.log('New Folder Path after Back:', newPath);
      }
    }
  }

  // Hide Back on exact routes or testscreens
  const hideOnExactPaths = ['/level', '/instruction'];
  const hideOnTestScreen = location.pathname.startsWith('/testscreen');

  // Additionally hide Back when user is at Module level (level === 1)
  const hideOnModuleLevel = level === 0;

  // Show Back button only when none of the hide conditions apply
  const showBackButton = 
    !hideOnExactPaths.includes(location.pathname) &&
    !hideOnTestScreen &&
    !hideOnModuleLevel;

  return (
    <div className="navContainer"> 
      <div className="buttonContainer">
        {/* Show Home button only after level > 0 */}
        {level > 0 && <Button handleClick={handleHome} buttonName="Homepage" />}
        {showBackButton && <Button handleClick={handleBack} buttonName="Back" />}
        <Button handleClick={handleSignOut} buttonName="Sign out" />
      </div>
    </div>
  );
}

export default Navbar;
